import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import { ifAuthenticated } from "../access";

import CdpDetail from "@/pages/Pages/CDP/CdpDetail.vue";
import CdpDetailInfo from "@/pages/Pages/CDP/CdpDetailInfo.vue";
import WhatsappGroup from "@/pages/Pages/Whatsapp/WhatsappGroup.vue";
import CdpGroup from "@/pages/Pages/CDP/CdpGroup.vue";

const cdpMenu = {
    path: "/cdp",
    component: DashboardLayout,
    beforeEnter: ifAuthenticated,
    redirect: "/cdp/detail",
    name: "CDP",
    children: [
        {
            path: "detail",
            name: "cdp_detail",
            components: { default: CdpDetail },
            meta: {
                icon: "article",
                msgKey: 'menu.item.statistics.call.detail'
            },
        },
        {
            path: "detail/:id",
            name: "cdp_detail_info",
            components: { default: CdpDetailInfo },
            meta:{
                icon: "forum",
                parentPath: "/cdp/detail",
                msgKey: 'menu.item.statistics.call.detail'
            }
        },
        {
            path: "group",
            name: "cdp_group",
            components: { default: CdpGroup },
            meta: {
                icon: "forum",
                msgKey: 'menu.item.statistics.whatsapp.group'
            },
        },
    ],
};

export default cdpMenu;
